import mirror from 'mirrorx';
import count from 'word-count';
import FileProviders from '../enums/file-providers';
import Pages from '../enums/pages';

let merge = require('lodash.merge');

function initializeModels() {

	// declare Redux state, reducers and actions,
	// all actions will be added to `actions`.
	mirror.defaults({

	});
	mirror.model({
	  name: 'app',
	  initialState: {
	  	defaultController: FileProviders.DROPBOX,
	  },
	  reducers: {
	    
	  }
	});

	mirror.model({
  	  name: 'layout',
	  initialState: {
	    sidebar: {
	      name: "Sidebar",
	      size: 256,
	      real_size: 256,
	      prev_size: -1,
	      direction: 1,
	      minSize: 16
	    },
	    filebar: {
	    	open: false
	    },
	    loading: false,
	    currentPage: Pages.TEXTAREA
	  },
	  reducers: {
	  	setIsLoading(state, data) {
	  		return merge({}, state, {
	  			loading: data
	  		});
	  	},
	  	setPage(state, data) {
	  		return merge({}, state, {
	  			currentPage: data
	  		});
	  	},
	  	setFilebarIsOpen(state, data) {
	  		let newState = merge({}, state, {
	  			filebar: {
	  				open: data
	  			}
	  		});
	  		return newState;
	  	},
	    changeSidebarSize(state, data) {
	      /// we need to use merge because otherwise the entirety of sidebar will be replaced
	      let newState = merge({}, state, {
	        sidebar: {
	          size: data
	        }
	      });
	      return newState;
	    },
	    updateSidebarSize(state, data) {
	      /// we need to use merge because otherwise the entirety of sidebar will be replaced
	      let newState = merge({}, state, {
	        sidebar: {
	          real_size: data
	        }
	      });
	      return newState;
	    },
	    setSidebarSavedSize(state, data) {
	      /// we need to use merge because otherwise the entirety of sidebar will be replaced
	      let newState = merge({}, state, {
	        sidebar: {
	          prev_size: data
	        }
	      });
	      return newState;
	    },
	    setSidebarState(state, data) {
	      let newState = merge({}, state, {
	        sidebar: data
	      });
	      return newState;
	    }
	  }
	})

	mirror.model({
		name: 'services',
		initialState: {
			dropboxAccessToken: null,
			dropboxClientId: 'xoadlhm8f0y5x3t'
		},
		reducers: {
			addDropboxAccessToken(state, data) {
				return merge({}, state, {
					dropboxAccessToken: data
				});
			}
		}
	})

	mirror.model({
		name: 'editor',
		initialState: {
			format: 'markdown',
			text: '',
			isDirty: false,
			hasBeenSaved: false,
			stats: {
				words: 0,
				characters: 0
			},
			file: {
				service: FileProviders.DROPBOX,
				path: '/',
				name: 'untitled'
			},
			temp: {
				jump: -1
			}
		},
		reducers: {
			reset(state) {
				let newState = {
					format: 'markdown',
					text: '',
					isDirty: false,
					hasBeenSaved: false,
					stats: {
						words: 0,
						characters: 0
					},
					file: {
						service: FileProviders.DROPBOX,
						path: '/',
						name: 'untitled'
					},
					temp: {
						jump: -1
					}
				};
				return newState;
			},
			updateText(state, data) {
				let wordCount = count(data);
				let newState = merge({}, state, {
			        text: data,
			        stats: {
			        	words: wordCount,
			        	characters: data.length
			        }
			    });
			    return newState;
			},
			updateFileMetadata(state, data) {
				return merge({}, state, {
					file: data
				});
			},
			updateDirty(state, data) {
				return merge({}, state, {
					isDirty: data
				});
			},
			updateHasBeenSaved(state, data) {
				return merge({}, state, {
					hasBeenSaved: data
				});
			},
			jumpToLine(state, data) {
				return merge({}, state, {
					temp: {
						jump: data
					}
				});
			}
		}
	});

	mirror.model({
		name: 'autosave',
		initialState: {
			recentPaths: [],
			maxPaths: 10,
			autosaves: []
		},
		reducers: {
			updateRecentPaths(state, data) {
				return merge({}, state, {
					recentPaths: data
				});
			},
			removeItem(state, item) {
				let paths = state.recentPaths.slice();
				const i = paths.map(function(e) {
					return e.path + e.name;
				}).indexOf(item.path + item.name);

				if (i > -1) {
					paths.splice(i, 1);
				}

				const newState = merge({}, state);
				newState.recentPaths = paths;

				return newState;
			},
			addRecentPath(state, data) {
				let paths = state.recentPaths.slice();
				while (paths.length > state.maxPaths) {
					paths.pop();
				}

				const i = paths.map(function(e) {
					return e.path + e.name;
				}).indexOf(data.path + data.name);

				if (i > -1) {
					paths.splice(i, 1);
				}
				paths.unshift(data);

				return merge({}, state, {
					recentPaths: paths
				});
			}
		}
	})
	
}

export default initializeModels;


// WEBPACK FOOTER //
// ./src/models/models.js